import { motion } from "framer-motion";
import { useLanguage } from "../i18n";

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] },
});

export const Intro = () => {
  const { t } = useLanguage();
  return (
    <section id="intro" data-testid="intro-section" className="relative py-28 md:py-40 overflow-hidden">
      <span className="absolute -top-8 right-4 md:right-10 font-display font-bold text-[26vw] md:text-[18rem] leading-none text-white/[0.03] select-none pointer-events-none" aria-hidden="true">
        01
      </span>
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <motion.p {...fadeUp()} className="font-mono text-xs uppercase tracking-[0.3em] text-brand-cyan mb-6" data-testid="intro-chapter-label">
          {t.chapters.intro}
        </motion.p>

        <motion.h2 {...fadeUp(0.05)} className="font-display font-semibold tracking-tight text-4xl md:text-5xl leading-[1.05] max-w-3xl" data-testid="intro-title">
          {t.intro.title}
        </motion.h2>

        <div className="mt-14 grid lg:grid-cols-12 gap-12">
          <motion.div {...fadeUp(0.1)} className="lg:col-span-7 space-y-6">
            <p className="font-mono text-sm md:text-base text-white/60 leading-relaxed" data-testid="intro-paragraph-1">{t.intro.p1}</p>
            <p className="font-mono text-sm md:text-base text-white/60 leading-relaxed" data-testid="intro-paragraph-2">{t.intro.p2}</p>
          </motion.div>

          <motion.div {...fadeUp(0.2)} className="lg:col-span-5 rounded-lg border border-white/5 bg-ink-surface p-7 md:p-9 h-fit">
            <h3 className="font-display font-medium text-xl md:text-2xl tracking-tight text-gradient-electric" data-testid="intro-meta-title">
              {t.intro.metaTitle}
            </h3>
            <p className="mt-4 font-mono text-xs md:text-sm text-white/50 leading-relaxed">{t.intro.metaIntro}</p>
            <div className="mt-7 space-y-7">
              {t.intro.items.map((item, i) => (
                <div key={item.title} className="flex gap-4" data-testid={`intro-item-${i}`}>
                  <span className="font-display font-bold text-lg text-brand-cyan/60 shrink-0">{String(i + 1).padStart(2, "0")}</span>
                  <div>
                    <h4 className="font-display font-medium text-base md:text-lg tracking-tight">{item.title}</h4>
                    <p className="mt-2 font-mono text-xs text-white/45 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>

        <motion.blockquote
          {...fadeUp(0.1)}
          className="mt-16 border-l-2 border-brand-green/60 pl-6 md:pl-8 max-w-4xl"
          data-testid="intro-closing"
        >
          <p className="font-display font-medium text-xl md:text-2xl tracking-tight leading-snug text-white/85">
            {t.intro.closing}
          </p>
        </motion.blockquote>
      </div>
    </section>
  );
};
